import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import RightLeaf from "./images/right-leaf.svg";
import LeftLeaf from "./images/left-leaf.svg";
import { Text } from "@cars24/turbo-web/lib/text";
import priceFormatter from "../../../utils/helpers/price-formatter";
import isNumber from "../../../utils/helpers/is-number";
import { NUMBER } from "../../../constants/app-constants";

const EChallanCount = ({
    challanCountData = {}
}) => {

    const { challanCount = 0, inputFieldHelpText = "" } = challanCountData || {};
    const { tokens } = useTokens();

    return (
        <div styleName={"styles.wrapper"}>
            <div styleName={"styles.countWrapper"}>
                <img src={LeftLeaf} />
                <Text size="400" fontWeight="bold" color={tokens.background_fill_misc_fill_purple}>
                    ₹{isNumber(challanCount) ? priceFormatter(challanCount) : NUMBER.ZERO}
                </Text>
                <img src={RightLeaf} />
            </div>
            <Text size="200" fontWeight="regular" color={tokens.background_fill_misc_fill_purple}>{inputFieldHelpText}</Text>
        </div>
    );
};

EChallanCount.propTypes = {
    challanCountData: PropTypes.object
};

export default EChallanCount;
